<div class="main-layout">
  <div class="header-container">
    <app-quotation-top-header></app-quotation-top-header>
    <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
  </div>

  <div class="content-wrapper" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
    <div class="dashboard-container" [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
      *ngIf="!loading" @fadeIn>
      <!-- Key Metrics Section with hover animations -->
      <div class="dashboard-head-container"
        [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}">
        <!-- Left Side - Metric Cards -->
        <div class="left-section">
          <div class="p-grid metric-cards-container" @staggerIn>
            <!-- First two cards - align left -->
            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="custom-metric-card payment-received align-right"
                [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
                [ngStyle]="{'min-width': filter ? '130px' : '170px'}" @hoverScale>
                <div class="custom-metric-content">
                  <img src="../../../../assets/quotation-dashboard/History.png" alt="Quotations Icon"
                    class="metric-icon" />
                  <h3 class="custom-metric-title">{{ getMetricTitle('Total Quotations') }}</h3>
                  <p class="custom-metric-value">
                    {{ filteredQuotations }}
                  </p>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="custom-metric-card total-revenue align-left"
                [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
                [ngStyle]="{'min-width': filter ? '130px' : '170px'}" @hoverScale (click)="openDetailDialog('quotation')">
                <div class="custom-metric-content">
                  <img src="../../../../assets/quotation-dashboard/Checked.png" alt="Quotations Icon"
                    class="metric-icon" />
                  <h3 class="custom-metric-title">{{ getMetricTitle('Total Quote Values') }}</h3>
                  <p class="custom-metric-value">
                    {{ formatCurrency(totalQuarter) }}
                  </p>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="custom-metric-card payment-pending align-right"
                [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
                [ngStyle]="{'min-width': filter ? '130px' : '170px'}" @hoverScale (click)="openDetailDialog('po')">
                <div class="custom-metric-content">
                  <img src="../../../../assets/quotation-dashboard/Checked.png" alt="Quotations Icon"
                    class="metric-icon" />
                  <h3 class="custom-metric-title">{{ getMetricTitle('Total Po Values') }}</h3>
                  <p class="custom-metric-value">
                    {{ formatCurrency(poAmount) }}
                  </p>
                  <p class="custom-metric-subtitle">{{ totalpo }} quotations</p>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
              <div class="custom-metric-card payment-pending align-right"
                [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
                [ngStyle]="{'min-width': filter ? '130px' : '170px'}" @hoverScale (click)="openDetailDialog('invoice')">
                <div class="custom-metric-content">
                  <img src="../../../../assets/quotation-dashboard/File.png" alt="Quotations Icon"
                    class="metric-icon" />
                  <h3 class="custom-metric-title">{{ getMetricTitle('Total Invoice Values') }}</h3>
                  <p class="custom-metric-value">
                    {{ formatCurrency(invoiceAmount) }}
                  </p>
                  <p class="custom-metric-subtitle">
                    {{ totalInvoice }} quotations
                  </p>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3"
              [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}">
              <div class="custom-metric-card payment-received align-right"
                [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}"
                [ngStyle]="{'min-width': filter ? '130px' : '170px'}" @hoverScale (click)="openDetailDialog('revenue')">
                <div class="custom-metric-content">
                  <img src="../../../../assets/quotation-dashboard/History.png" alt="Quotations Icon"
                    class="metric-icon" />
                  <h3 class="custom-metric-title">{{ getMetricTitle('Total Revenue') }}</h3>
                  <p class="custom-metric-value">
                    {{ formatCurrency(totalRavenue) }}
                  </p>
                  <p class="custom-metric-subtitle">
                    {{ paidQuotations }} quotations
                  </p>
                </div>
              </div>
            </div>
          </div>


          <div class="chart-section" style="width: 100% !important;">
            <!-- Monthly Revenue Chart -->
            <div class="p-col-12 p-md-6" style="width: 50%; height: 250px">
              <p-card styleClass="chart-card" @slideInRight class="customer-chart-card">
                <div
                  style="display: flex; justify-content: space-between; align-items: center;margin-top: -12px;padding-bottom: 6px;">
                  <h1 style="margin: 0;font-size: 14px;color: #002B4D;">Customer by {{selectedDataType==='revenue' ?
                    'Revenue' : selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Po Values'}}</h1>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <!-- Chart type toggle button -->
                    <button style="background-color: transparent; border: none; cursor: pointer; padding: 4px;"
                      (click)="toggleChartType()"
                      pTooltip="{{isLineChart ? 'Switch to Bar Chart' : 'Switch to Line Chart'}}"
                      tooltipPosition="left">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path [attr.d]="isLineChart ? 'M2 14L6 10L10 12L14 8' : 'M3 14V8M7 14V4M11 14V6M15 14V10'"
                          stroke="#002B4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <button
                      style="background-color: transparent; border: none; width: 13px; height: 13px; cursor: pointer;"
                      (click)="openChartDialog('monthlyRevenue')">
                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.28833 11.4583H1.53833V7.91666M8.28833 1.54166H12.0383V5.08332" stroke="#002B4D"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="chart-header">
                  <div class="dropdown-section">
                    <p-dropdown [options]="Indcustomers" [filter]="true" [(ngModel)]="selectedIndCustomer"
                      placeholder="Select a customer" optionLabel="label" optionValue="value"
                      (onChange)="updateMonthlyRevenueChart()"
                      [style]="{ 'background-color': '#B8E2A3','max-width': '90px', height: '20px' }"
                      class="custom-selection">
                    </p-dropdown>
                    <p-dropdown [options]="yearTypes" [(ngModel)]="selectedIndYearType" placeholder="Select Year Type"
                      optionLabel="name" optionValue="value" (onChange)="updateMonthlyRevenueChart()"
                      [style]="{ 'background-color': '#B8E2A3','max-width': '90px', height: '20px' }"
                      class="custom-selection">
                    </p-dropdown>
                    <div class="year-dropdown-section">
                      <p-dropdown [options]="CustomeryearOptions" [(ngModel)]="CustomerStartYear"
                        placeholder="Start Year" (onChange)="updateMonthlyRevenueChart()"
                        [style]="{ 'background-color': '#B8E2A3', height: '20px','border-right':'none' }"
                        class="custom-selection">
                      </p-dropdown>
                      <p-dropdown [options]="CustomeryearOptions" [(ngModel)]="CustomerEndYear" placeholder="End Year"
                        (onChange)="updateMonthlyRevenueChart()"
                        [style]="{ 'background-color': '#B8E2A3', height: '20px','border-left':'none','margin-left':'-1px' }"
                        class="custom-selection">
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="radio-section">
                    <p-radioButton name="chartDataType" value="revenue" [(ngModel)]="selectedDataType"
                      (onClick)="updateMonthlyRevenueChart()" label="Revenue"></p-radioButton>
                    <p-radioButton name="chartDataType" value="invoiceValue" [(ngModel)]="selectedDataType"
                      (onClick)="updateMonthlyRevenueChart()" label="Invoice Values"></p-radioButton>
                    <p-radioButton name="chartDataType" value="poValue" [(ngModel)]="selectedDataType" label="Po Values"
                      (onClick)="updateMonthlyRevenueChart()"></p-radioButton>
                  </div>
                </div>
                <div class="line-chart-container" style="height: 500px">
                  <p-chart [type]="chartType" height="320" [data]="monthlyRevenueData"
                    [options]="chartOptions"></p-chart>
                </div>
              </p-card>
            </div>

            <!-- Customer Distribution Chart -->
            <div class="p-col-12 p-md-6" style="width: 50%; height: 290px">
              <p-card styleClass="chart-card" @slideInLeft class="customer-chart-card">
                <div
                  style="display: flex; justify-content: space-between; align-items: center; margin-top: -12px; padding-bottom: 8px;">
                  <h1 style="margin: 0; font-size: 14px; color: #002B4D;">
                    Top 2 Customers by {{ selectedDataType === 'revenue' ? 'Revenue' : selectedDataType ===
                    'invoiceValue' ? 'Invoice Values' : 'Po Values' }}
                  </h1>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <!-- Chart type toggle button -->
                    <button style="background-color: transparent; border: none; cursor: pointer; padding: 4px;"
                      (click)="toggleCustomerChartType()"
                      pTooltip="{{isCustomerLineChart ? 'Switch to Bar Chart' : 'Switch to Line Chart'}}"
                      tooltipPosition="left">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          [attr.d]="isCustomerLineChart ? 'M2 14L6 10L10 12L14 8' : 'M3 14V8M7 14V4M11 14V6M15 14V10'"
                          stroke="#002B4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <button
                      style="background-color: transparent; border: none; width: 13px; height: 13px; cursor: pointer; padding-bottom: 6px;"
                      (click)="openChartDialog('customerDistribution')">
                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.28833 11.4583H1.53833V7.91666M8.28833 1.54166H12.0383V5.08332" stroke="#002B4D"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="chart-header">
                  <div class="dropdown-section">
                    <p-dropdown [options]="yearOptions" [(ngModel)]="startYear" placeholder="Start Year"
                      [style]="{ 'max-width':'50px', height: '20px', 'background-color': '#B8E2A3' }"
                      class="custom-selection" id="custom-dropdown-chart" (onChange)="updateCustomerChart()">
                    </p-dropdown>
                    <span>to</span>
                    <p-dropdown [options]="yearOptions" [(ngModel)]="endYear" placeholder="End Year"
                      [style]="{'max-width':'50px', height: '20px', 'background-color': '#B8E2A3' }"
                      class="custom-selection" (onChange)="updateCustomerChart()">
                    </p-dropdown>
                    <p-multiSelect [options]="customers" [(ngModel)]="selectedCustomers"
                      placeholder="Select up to 2 customers" [maxSelectedLabels]="5"
                      [style]="{ 'max-width':'100px',height: '20px', 'background-color': '#B8E2A3' }"
                      class="custom-selection" (onChange)="updateCustomerChart()">
                    </p-multiSelect>
                    <!-- Add Filter Button -->
                    <button pButton type="button" icon="pi pi-filter" (click)="applyChartFilters()"
                      style="margin-left: 10px; background-color: #B8E2A3; border: none; height: 20px; line-height: 20px; padding: 0 8px;">
                    </button>
                  </div>
                  <div class="radio-section">
                    <p-radioButton name="chartDataType" value="revenue" [(ngModel)]="selectedDataType"
                      (onClick)="updateCustomerChart()" label="Revenue"></p-radioButton>
                    <p-radioButton name="chartDataType" value="invoiceValue" [(ngModel)]="selectedDataType"
                      (onClick)="updateCustomerChart()" label="Invoice Values"></p-radioButton>
                    <p-radioButton name="chartDataType" value="poValue" [(ngModel)]="selectedDataType"
                      (onClick)="updateCustomerChart()" label="Po Values"></p-radioButton>
                  </div>
                </div>
                <div class="chart-container">
                  <p-chart [type]="customerChartType" height="320" [data]="customerDistributionData"
                    [options]="customerChartOptions"></p-chart>
                </div>
              </p-card>
            </div>
          </div>
        </div>

        <!-- Right Side - Dashboard Header with Filter and Chart -->
        <div class="right-section">
          <div class="dashboard-header" [ngClass]="{'collapsed': !isHeaderCollapsed, 'expanded': isHeaderCollapsed}">
            <h2 class="financial-title">Financial Performance</h2>
            <!-- Filter Panel -->
            <div class="filter-panel-container" @slideInUp>
              <div class="filter-card-custom">
                <div class="year-type-selector">
                  <div class="toggle-wrapper">
                    <span class="toggle-label" [class.active-label]="selectedYearType === 'calendar'">Calendar</span>
                    <p-inputSwitch [(ngModel)]="yearTypeSwitch" (onChange)="onYearTypeToggle()"></p-inputSwitch>
                    <span class="toggle-label" [class.active-label]="selectedYearType === 'financial'">Financial</span>
                  </div>
                </div>
                <div class="filter-content">
                  <!-- Customer Dropdown -->
                  <div class="filter-field">
                    <span class="p-float-label">
                      <p-dropdown [options]="customers" [(ngModel)]="selectedCustomer" placeholder="Select Customer"
                        [showClear]="true" styleClass="w-full" [filter]="true" class="custom-selection"
                        filterPlaceholder="Search customers"
                        [style]="{ 'background-color': '#B8E2A3', 'height': '22px' }"></p-dropdown>
                      <label>Customer</label>
                    </span>
                  </div>

                  <!-- Calendar Year Selection -->
                  <div class="filter-field" *ngIf="selectedYearType === 'calendar'" @fadeIn>
                    <span class="p-float-label">
                      <p-dropdown [options]="calendarYears" [(ngModel)]="selectedCalendarYear"
                        placeholder="Select Calendar Year" [showClear]="true" styleClass="w-full" optionLabel="name"
                        class="custom-selection" [style]="{ 'background-color': '#B8E2A3','height':'22px' }">
                      </p-dropdown>
                      <label>Calendar Year</label>
                      <small *ngIf="selectedCalendarYear" class="text-muted">
                        {{ formatCalendarYearRange(selectedCalendarYear) }}
                      </small>
                    </span>
                  </div>

                  <!-- Financial Year Selection -->
                  <div class="filter-field" *ngIf="selectedYearType === 'financial'" @fadeIn>
                    <span class="p-float-label">
                      <p-dropdown [options]="financialYears" [(ngModel)]="selectedFinancialYear"
                        placeholder="Select Financial Year" [showClear]="true" styleClass="w-full"
                        [style]="{ 'background-color': '#B8E2A3','height':'22px' }" optionLabel="name"
                        class="custom-selection">
                      </p-dropdown>
                      <label>Financial Year</label>
                      <small *ngIf="selectedFinancialYear" class="text-muted">
                        {{ formatFinancialYearRange(selectedFinancialYear) }}
                      </small>
                    </span>
                  </div>


                  <!-- Month Filter -->
                  <div class="filter-field" *ngIf="selectedYearType" @fadeIn>
                    <span class="p-float-label">
                      <p-dropdown [options]="availableMonths" [(ngModel)]="selectedMonth" placeholder="Select Month"
                        [showClear]="true" styleClass="w-full"
                        [style]="{ 'background-color': '#B8E2A3','height':'22px'   }" optionLabel="name"
                        optionValue="value" class="custom-selection"></p-dropdown>
                      <label>Month</label>
                    </span>
                  </div>

                  <!-- Filter Action Buttons -->
                  <div class="top-filter-buttons" @fadeIn>
                    <button pButton type="button" label="Apply" icon="pi pi-filter" class="p-button-success"
                      [style]="{ 'background-color': '#185DDF','height':'22px' }" (click)="applyFilters()"
                      [disabled]="!selectedYearType"></button>
                    <button pButton type="button" label="Reset" icon="pi pi-refresh" class="p-button-outlined"
                      [style]="{ 'background-color': '#BFBFBF','height':'22px' }" (click)="resetFilters()"
                      class="custom-selection"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="payment-chart-container">
              <div class="chart-header-section">
                <!-- Main title -->
                <h3>Payment Status Overview</h3>

                <p-toggleButton [(ngModel)]="isToggleOn" [onLabel]="getToggleOnLabel()" [offLabel]="getToggleOffLabel()"
                  styleClass="chart-view-switcher" (onChange)="onChartToggleChange()">
                </p-toggleButton>
              </div>

              <div class="payment-charts-wrapper">
                <!-- Quote vs PO Chart (View 0) -->
                <div class="chart-panel" *ngIf="currentChartView === 'quote-vs-po'">
                  <div class="chart-title-bar">
                    <h4>Quotation vs Purchase Order</h4>
                  </div>
                  <div class="chart-display-area">
                    <p-chart type="pie" height="200" [data]="quoteVsPoData" [options]="quoteVsPoOptions">
                    </p-chart>
                  </div>
                </div>

                <!-- PO vs INV Chart (View 1) -->
                <div class="chart-panel" *ngIf="currentChartView === 'po-vs-inv'">
                  <div class="chart-title-bar">
                    <h4>PO vs Invoice</h4>
                  </div>
                  <div class="chart-display-area">
                    <p-chart type="pie" height="200" [data]="poVsInvData" [options]="poVsInvOptions">
                    </p-chart>
                  </div>
                </div>

                <!-- INV vs REV Chart (View 2) -->
                <div class="chart-panel" *ngIf="currentChartView === 'inv-vs-rev'">
                  <div class="chart-title-bar">
                    <h4>Invoice vs Revenue</h4>
                  </div>
                  <div class="chart-display-area">
                    <p-chart type="pie" height="200" [data]="invVsRevData" [options]="invVsRevOptions">
                    </p-chart>
                  </div>
                </div>
              </div>

              <div class="payment-actions">
                <p-button class="custom-action-btn" label="View Due Payments" icon="pi pi-eye"
                  (click)="openDueQuotationDialog()">
                </p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-section" style="width: 100% !important;padding-bottom: 140px;">
        <!--Total Sales Chart -->
        <div class="p-col-12 p-md-6" style="width: 50%; height: 290px">
          <p-card styleClass="chart-card" @slideInRight class="total-sales-chart-card">
            <div
              style="display: flex; justify-content: space-between; align-items: center; margin-top: -12px; padding-bottom: 8px;">
              <h1 style="margin: 0; font-size: 14px; color: #002B4D;">
                Total Sales by {{ selectedDataType === 'revenue' ? 'Revenue' : selectedDataType === 'invoiceValue' ?
                'Invoice Values' : 'Po Values' }}
              </h1>
              <div style="display: flex; align-items: center; gap: 8px;">
                <!-- Chart type toggle button -->
                <button style="background-color: transparent; border: none; cursor: pointer; padding: 4px;"
                  (click)="toggleTotalSalesChartType()"
                  pTooltip="{{isTotalSalesLineChart ? 'Switch to Bar Chart' : 'Switch to Line Chart'}}"
                  tooltipPosition="left">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path [attr.d]="isTotalSalesLineChart ? 'M2 14L6 10L10 12L14 8' : 'M3 14V8M7 14V4M11 14V6M15 14V10'"
                      stroke="#002B4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button
                  style="background-color: transparent; border: none; width: 13px; height: 13px; cursor: pointer; padding-bottom: 6px;"
                  (click)="openChartDialog('totalSales')">
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.28833 11.4583H1.53833V7.91666M8.28833 1.54166H12.0383V5.08332" stroke="#002B4D"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="chart-header">
              <div class="dropdown-section">
                <p-dropdown [filter]="true" [options]="customers" [(ngModel)]="selectedTotalSalesCustomer"
                  placeholder="Select a customer" optionLabel="label" optionValue="value"
                  (onChange)="updateTotalSalesChart()"
                  [style]="{ 'background-color': '#B8E2A3', 'max-width': '100px', height: '20px' }"
                  class="custom-selection">
                </p-dropdown>
                <p-dropdown [options]="yearTypes" [(ngModel)]="selectedTotalSalesYearType"
                  placeholder="Select Year Type" optionLabel="name" optionValue="value"
                  (onChange)="updateTotalSalesChart()"
                  [style]="{ 'background-color': '#B8E2A3', 'max-width': '90px', height: '20px' }"
                  class="custom-selection">
                </p-dropdown>
                <div class="year-dropdown-section">
                  <p-dropdown [options]="yearOptions" [(ngModel)]="totalSalesStartYear" placeholder="Start Year"
                    (onChange)="updateTotalSalesChart()"
                    [style]="{ 'background-color': '#B8E2A3', 'max-width': '50px', height: '20px', 'border-right': 'none' }"
                    class="custom-selection">
                  </p-dropdown>
                  <p-dropdown [options]="yearOptions" [(ngModel)]="totalSalesEndYear" placeholder="End Year"
                    (onChange)="updateTotalSalesChart()"
                    [style]="{ 'background-color': '#B8E2A3', 'max-width': '50px', height: '20px', 'border-left': 'none', 'margin-left': '-1px' }"
                    class="custom-selection">
                  </p-dropdown>
                </div>
              </div>
              <div class="radio-section">
                <p-radioButton name="chartDataType" value="revenue" [(ngModel)]="selectedDataType"
                  (onClick)="updateTotalSalesChart()" label="Revenue"></p-radioButton>
                <p-radioButton name="chartDataType" value="invoiceValue" [(ngModel)]="selectedDataType"
                  (onClick)="updateTotalSalesChart()" label="Invoice Values"></p-radioButton>
                <p-radioButton name="chartDataType" value="poValue" [(ngModel)]="selectedDataType"
                  (onClick)="updateTotalSalesChart()" label="Po Values"></p-radioButton>
              </div>
            </div>
            <div class="chart-container">
              <p-chart [type]="totalSalesChartType" height="255" [data]="totalSalesData"
                [options]="totalSalesChartOptions"></p-chart>
            </div>
          </p-card>
        </div>
        <!-- Accumulative Annual Sales Chart -->
        <div class="p-col-12 p-md-6" style="width: 50%; height: 277px">
          <p-card styleClass="chart-card" @slideInLeft class="annual-sales-chart-card">
            <div
              style="display: flex; justify-content: space-between; align-items: center; margin-top: -12px; padding-bottom: 8px;">
              <h1 style="margin: 0; font-size: 14px; color: #002B4D;">
                Accumulative Annual Sales ({{ selectedDataType === 'revenue' ? 'Revenue' :
                selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Po Values' }})
              </h1>
              <div style="display: flex; align-items: center; gap: 8px;">
                <button style="background-color: transparent; border: none; cursor: pointer; padding: 4px;"
                  (click)="toggleAccuChartType()"
                  pTooltip="{{isAccumulativeLineChart ? 'Switch to Bar Chart' : 'Switch to Line Chart'}}"
                  tooltipPosition="left">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      [attr.d]="isAccumulativeLineChart ? 'M2 14L6 10L10 12L14 8' : 'M3 14V8M7 14V4M11 14V6M15 14V10'"
                      stroke="#002B4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button
                  style="background-color: transparent; border: none; width: 13px; height: 13px; cursor: pointer; padding-bottom: 6px;"
                  (click)="openChartDialog('annualSales')">
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.28833 11.4583H1.53833V7.91666M8.28833 1.54166H12.0383V5.08332" stroke="#002B4D"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="chart-header">
              <div class="dropdown-section">
                <p-dropdown [options]="customers" [filter]="true" [(ngModel)]="selectedTotalAnnualSalesCustomer"
                  placeholder="Select a customer" optionLabel="label" optionValue="value"
                  (onChange)="updateAnnualSalesChart()"
                  [style]="{ 'background-color': '#B8E2A3', 'max-width': '100px', height: '20px' }"
                  class="custom-selection">
                </p-dropdown>
                <p-dropdown [options]="yearTypes" [(ngModel)]="selectedTotalAnnualSalesYearType"
                  placeholder="Select Year Type" optionLabel="name" optionValue="value"
                  (onChange)="updateAnnualSalesChart()"
                  [style]="{ 'background-color': '#B8E2A3', 'max-width': '90px', height: '20px' }"
                  class="custom-selection">
                </p-dropdown>
                <p-dropdown [options]="yearOptions" [(ngModel)]="selectedTotalAnnualSalesYear" placeholder="Select Year"
                  (onChange)="updateAnnualSalesChart()"
                  [style]="{ 'background-color': '#B8E2A3', 'max-width': '60px', height: '20px' }"
                  class="custom-selection">
                </p-dropdown>
              </div>
              <div class="radio-section">
                <p-radioButton name="chartDataType" value="revenue" [(ngModel)]="selectedDataType"
                  (onClick)="updateAnnualSalesChart()" label="Revenue"></p-radioButton>
                <p-radioButton name="chartDataType" value="invoiceValue" [(ngModel)]="selectedDataType"
                  (onClick)="updateAnnualSalesChart()" label="Invoice Values"></p-radioButton>
                <p-radioButton name="chartDataType" value="poValue" [(ngModel)]="selectedDataType"
                  (onClick)="updateAnnualSalesChart()" label="Po Values"></p-radioButton>
              </div>
            </div>
            <div class="chart-container">
              <p-chart [type]="annualSalesChartType" height="255" [data]="annualSalesData"
                [options]="annualSalesChartOptions"></p-chart>
            </div>
          </p-card>
        </div>
      </div>

      <div class="chart-section">
        <!-- Recent Quotations Table with enhanced features -->
        <div class="p-grid charts-container" style="border-radius: 15px; width: 50%">
          <p-card styleClass="table-card" styleClass="chart-card" @slideInRight class="customer-chart-card"
            id="customer-chart">
            <div class="table-header">
              <h1 style="color: #002B4D;font-size: 14px;">Recent Quotations</h1>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
                <input type="text" class="form-control" (input)="applyTableFilter($event)"
                  placeholder="Search quotations..." />
              </div>
            </div>
            <p-table [value]="filteredItems" [scrollable]="true" scrollHeight="400px" [paginator]="true" [rows]="10"
              [rowsPerPageOptions]="[5, 10, 25]" [globalFilterFields]="[
           'quotationNo',
           'customerName',
           'projectName'
         ]" [loading]="tableLoading" [sortField]="'quotationDate'" [sortOrder]="-1"
              styleClass="p-datatable-responsive p-datatable-gridlines p-datatable-striped" responsiveLayout="scroll"
              class="custom-table">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="quotationNo">
                    Quotation No
                  </th>
                  <th pSortableColumn="customerName">
                    Customer
                  </th>
                  <th pSortableColumn="jobNumber">
                    Job Number
                  </th>
                  <th pSortableColumn="quotationDate">
                    Date
                  </th>
                  <th pSortableColumn="totalPrice">
                    Amount
                  </th>
                  <th pSortableColumn="paymentReceived">
                    Status
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>
                    <span class="p-column-title">Quotation No</span>{{ item.quotationNo }}
                  </td>
                  <td>
                    <span class="p-column-title">Customer</span>{{ item.customerName }}
                  </td>
                  <td>
                    <span class="p-column-title">Job Number</span>{{ item.jobNumber }}
                  </td>
                  <td>
                    <span class="p-column-title">Date</span>{{ item.quotationDate}}
                  </td>
                  <td>
                    <span class="p-column-title">Amount</span>{{ formatCurrency(item.totalPrice) }}
                  </td>
                  <td>
                    <span class="p-column-title">Status</span>
                    <p-tag class="custom-tag" [severity]="item.paymentReceived ? 'success' : 'warning'"
                      [value]="item.paymentReceived ? 'Paid' : 'Pending'"
                      [icon]="item.paymentReceived ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
                      class="custom-tag"></p-tag>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7" class="text-center">
                    <div class="empty-message">
                      <i class="pi pi-search" style="font-size: 2rem"></i>
                      <h4>No quotations found</h4>
                      <p>Try adjusting your filters or search criteria</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="loadingbody">
                <tr>
                  <td colspan="7" class="text-center">
                    <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </div>
        <!-- Charts Section with enhanced visualization -->
        <div class="p-grid charts-container" style="width: 50%;">
          <!-- Combined Yearly Amounts Chart -->
          <div class="p-col-12 p-md-12">
            <p-card header="Yearly Amounts Comparison (USD)" styleClass="chart-card" @slideInRight
              class="customer-chart-card" id="yearly-amounts-chart">
              <div class="chart-container">
                <p-chart type="bar" height="320" [data]="yearlyAmountsData" [options]="yearlyAmountsOptions"></p-chart>
              </div>
            </p-card>
          </div>
        </div>
      </div>
    </div>
    <!-- Quick Stats Footer -->
    <div class="dashboard-footer" @fadeIn>
      <div class="footer-stats">
        <div class="stat-item">
          <i class="pi pi-chart-line"></i>
          <div>
            <span>Avg. Quotation Value</span>
            <strong>{{ formatCurrency(averageQuotationValue) }}</strong>
          </div>
        </div>
        <div class="stat-item">
          <i class="pi pi-calendar"></i>
          <div>
            <span>Quotations This Month</span>
            <strong>{{ quotationsThisMonth }}</strong>
          </div>
        </div>
        <div class="stat-item">
          <i class="pi pi-wallet"></i>
          <div>
            <span>Revenue This Month</span>
            <strong>{{ formatCurrency(revenueThisMonth) }}</strong>
          </div>
        </div>
      </div>
      <div class="footer-actions">
        <button pButton type="button" icon="pi pi-refresh" label="Refresh Data"
          class="p-button-outlined p-button-rounded" (click)="refreshData()"></button>
      </div>
    </div>

    <!-- <div *ngIf="!loading" class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
  <p>Loading data...</p>
</div> -->
    <!-- Loading State with enhanced animation -->
    <div class="loading-container" *ngIf="loading" @fadeInOut>
      <div class="loading-content">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
          animationDuration=".5s"></p-progressSpinner>
        <h3>Loading Dashboard Data...</h3>
        <p>Preparing your financial insights</p>
        <div class="loading-progress">
          <p-progressBar mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>
        </div>
      </div>
    </div>

    <!-- Toast for notifications -->
    <p-toast position="top-right" [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"></p-toast>
  </div>
</div>

<!-- Dialog to display chart details -->
<p-dialog header="Chart Details" [(visible)]="displayDialog" [modal]="true" [style]="{width: '90%',height:'85%'}"
  [styleClass]="'custom-dialog'">
  <app-dashboard-chart-dialog [chartData]="dialogChartData" [chartOptions]="dialogChartOptions"
    [chartTitle]="dialogChartType" [chartLabels]="dialogChartLabels" [selectedCustomer]="selectedIndCustomer"
    [startYear]="startYear" [endYear]="endYear" [selectedDataType]="selectedDataType" [chartType]="chartType"
    [selectedTotalSalesCustomer]="selectedTotalSalesCustomer"
    [selectedTotalAnnualSalesCustomer]="selectedTotalAnnualSalesCustomer">
  </app-dashboard-chart-dialog>
</p-dialog>
<!-- ============================================================
     METRIC DETAIL DIALOG — p-dialog template
     Place inside your dashboard component template.
     Trigger: (click)="openDetailDialog('quotation'|'po'|'invoice'|'revenue')"
     ============================================================ -->

<p-dialog
  [(visible)]="detailDialogVisible"
  [modal]="true"
  [draggable]="true"
  [resizable]="true"
  [maximizable]="true"
  [style]="{ width: '85vw', maxWidth: '1100px', 'border-radius': '12px' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  [showHeader]="true"
  styleClass="detail-dialog"
  (onHide)="onDetailDialogHide()">

  <!-- ── Custom Header ─────────────────────────────────────── -->
  <ng-template pTemplate="header">
    <div class="dd-header" [ngClass]="'dd-header--' + detailDialogType">
      <div class="dd-header__left">
        <div class="dd-header__icon">
          <i [class]="dialogConfig[detailDialogType].icon"></i>
        </div>
        <div>
          <h3 class="dd-header__title">{{ dialogConfig[detailDialogType].title }}</h3>
          <p class="dd-header__subtitle">{{ dialogConfig[detailDialogType].subtitle }}</p>
        </div>
      </div>
      <div class="dd-header__badges">
        <span class="dd-header__badge dd-header__badge--count">
          {{ detailDialogItems.length }} Records
        </span>
        <span class="dd-header__badge dd-header__badge--amount">
          {{ formatCurrency(detailDialogTotalAmount) }}
        </span>
      </div>
    </div>
  </ng-template>

  <!-- ── Content ───────────────────────────────────────────── -->
  <ng-template pTemplate="content">

    <!-- Summary strip -->
    <div class="dd-summary">
      <div class="dd-summary__item" *ngFor="let s of detailSummaryStrip">
        <span class="dd-summary__label">{{ s.label }}</span>
        <span class="dd-summary__value" [ngClass]="'dd-summary__value--' + s.color">
          {{ s.formatted ? formatCurrency(s.value) : s.value }}
        </span>
      </div>
    </div>

    <!-- Body: list + detail -->
    <div class="dd-body">

      <!-- LEFT — item list -->
      <div class="dd-body__list">
        <!-- search -->
        <div class="dd-search">
          <span class="p-input-icon-left" style="width:100%;">
            <i class="pi pi-search"></i>
            <input pInputText type="text" placeholder="Search..."
              [(ngModel)]="detailSearchTerm"
              (input)="filterDetailItems()" />
          </span>
        </div>

        <!-- rows -->
        <div
          *ngFor="let item of filteredDetailItems; let i = index"
          class="dd-list-item"
          [class.is-active]="selectedDetailItem?.orderId === item.orderId"
          (click)="selectDetailItem(item)">

          <div class="dd-list-item__left">
            <span class="dd-list-item__no">{{ getItemPrimaryLabel(item) }}</span>
            <span class="dd-list-item__name">{{ item.customerName }}</span>
            <span class="dd-list-item__date">{{ getItemDateLabel(item) }}</span>
          </div>

          <div class="dd-list-item__right">
            <span class="dd-list-item__amount">{{ formatCurrency(getItemAmount(item)) }}</span>
            <span class="dd-list-item__badge" [ngClass]="getItemBadgeClass(item)">
              {{ getItemBadgeLabel(item) }}
            </span>
          </div>
        </div>

        <!-- empty list state -->
        <div *ngIf="filteredDetailItems.length === 0" style="padding:1.5rem;text-align:center;">
          <i class="pi pi-search" style="font-size:1.5rem;color:#d1d5db;"></i>
          <p style="font-size:0.75rem;color:#9ca3af;margin-top:0.5rem;">No records found</p>
        </div>
      </div>

      <!-- RIGHT — detail panel -->
      <div class="dd-body__detail">

        <!-- Empty state -->
        <div class="dd-empty" *ngIf="!selectedDetailItem">
          <i class="pi pi-arrow-left"></i>
          <p>Select a record to view details</p>
        </div>

        <!-- Detail content -->
        <ng-container *ngIf="selectedDetailItem as item">

          <!-- Header card -->
          <div class="dd-detail-header">
            <div class="dd-detail-header__top">
              <div>
                <h4 class="dd-detail-header__title">{{ getItemPrimaryLabel(item) }}</h4>
                <p class="dd-detail-header__customer">
                  <i class="pi pi-building" style="font-size:0.65rem;margin-right:3px;"></i>
                  {{ item.customerName }}
                  <span *ngIf="item.country" style="margin-left:6px;color:#9ca3af;">
                    <i class="pi pi-map-marker" style="font-size:0.6rem;"></i> {{ item.country }}
                  </span>
                </p>
              </div>
              <div class="dd-detail-header__status-row">
                <span class="dd-tag dd-tag--primary" *ngIf="item.jobNumber">
                  <i class="pi pi-hashtag"></i> {{ item.jobNumber }}
                </span>
                <span class="dd-tag" [ngClass]="getWorkflowStepTagClass(item.currentStep)">
                  <i class="pi pi-circle-fill" style="font-size:0.4rem;"></i>
                  {{ item.currentStep | titlecase }}
                </span>
                <span class="dd-tag dd-tag--success" *ngIf="item.completed">
                  <i class="pi pi-check"></i> Completed
                </span>
              </div>
            </div>

            <!-- Workflow stepper -->
            <div class="dd-stepper">
              <div class="dd-stepper__step"
                *ngFor="let step of workflowSteps"
                [class.is-done]="isStepDone(item, step.key)"
                [class.is-active]="item.currentStep === step.key">
                <div class="dd-stepper__dot">
                  <i [class]="isStepDone(item, step.key) ? 'pi pi-check' : step.icon"></i>
                </div>
                <span class="dd-stepper__label">{{ step.label }}</span>
              </div>
            </div>

            <!-- Meta grid -->
            <div class="dd-detail-header__meta">
              <div class="dd-meta-field" *ngIf="item.quotationNo">
                <span class="dd-meta-field__label">Quotation No</span>
                <span class="dd-meta-field__value">{{ item.quotationNo }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.quotationDate">
                <span class="dd-meta-field__label">Quote Date</span>
                <span class="dd-meta-field__value">{{ item.quotationDate | date:'dd MMM yyyy' }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.poNumber">
                <span class="dd-meta-field__label">PO Number</span>
                <span class="dd-meta-field__value">{{ item.poNumber }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.poDate">
                <span class="dd-meta-field__label">PO Date</span>
                <span class="dd-meta-field__value">{{ item.poDate | date:'dd MMM yyyy' }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.proformaInvoice">
                <span class="dd-meta-field__label">Proforma Inv.</span>
                <span class="dd-meta-field__value">{{ item.proformaInvoice }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.piDate">
                <span class="dd-meta-field__label">PI Date</span>
                <span class="dd-meta-field__value">{{ item.piDate | date:'dd MMM yyyy' }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.totalPrice">
                <span class="dd-meta-field__label">Quote Amount</span>
                <span class="dd-meta-field__value">{{ formatCurrency(item.totalPrice) }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.project">
                <span class="dd-meta-field__label">Project</span>
                <span class="dd-meta-field__value">{{ item.project }}</span>
              </div>
              <div class="dd-meta-field" *ngIf="item.email">
                <span class="dd-meta-field__label">Email</span>
                <span class="dd-meta-field__value dd-meta-field__value--link">{{ item.email }}</span>
              </div>
            </div>
          </div>

          <!-- ── INVOICES TREE ─────────────────────────────── -->
          <div class="dd-tree-section" *ngIf="detailDialogType !== 'quotation'">
            <div class="dd-tree-section__header">
              <span class="dd-tree-section__title">
                <i class="pi pi-file-invoice" style="color:#06b6d4;"></i>
                Invoices
              </span>
              <span class="dd-tree-section__total">
                <span>Total</span>{{ formatCurrency(calcTotalInvoices(item)) }}
              </span>
            </div>

            <!-- Invoice cards -->
            <ng-container *ngIf="item.invoices && item.invoices.length > 0; else noInvoices">
              <div class="dd-tree-card dd-tree-card--invoice"
                *ngFor="let inv of item.invoices; let ii = index">

                <!-- Toggle row -->
                <div class="dd-tree-card__toggle"
                  (click)="toggleTreeCard('inv-' + item.orderId + '-' + ii)">
                  <div class="dd-tree-card__toggle-left">
                    <div class="dd-tree-card__toggle-icon dd-tree-card__toggle-icon--invoice">
                      <i class="pi pi-file"></i>
                    </div>
                    <div>
                      <div class="dd-tree-card__toggle-title">{{ inv.invoiceNo }}</div>
                      <div class="dd-tree-card__toggle-date">{{ inv.date | date:'dd MMM yyyy' }}</div>
                    </div>
                  </div>
                  <div class="dd-tree-card__toggle-right">
                    <span class="dd-tree-card__toggle-amount">{{ formatCurrency(inv.invoicePrice) }}</span>
                    <span class="dd-tag dd-tag--info" style="font-size:0.58rem;">INV</span>
                    <i class="pi pi-chevron-down dd-tree-card__chevron"
                      [class.is-open]="isTreeCardOpen('inv-' + item.orderId + '-' + ii)"></i>
                  </div>
                </div>

                <!-- Expanded body -->
                <div class="dd-tree-card__body"
                  [class.is-open]="isTreeCardOpen('inv-' + item.orderId + '-' + ii)">
                  <div class="dd-tree-card__grid">
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Invoice No</span>
                      <span class="dd-tree-card__field-value">{{ inv.invoiceNo }}</span>
                    </div>
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Invoice Date</span>
                      <span class="dd-tree-card__field-value">{{ inv.date | date:'dd MMM yyyy' }}</span>
                    </div>
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Invoice Amount</span>
                      <span class="dd-tree-card__field-value">{{ formatCurrency(inv.invoicePrice) }}</span>
                    </div>
                    <div class="dd-tree-card__field" *ngIf="inv.paymentDueDate">
                      <span class="dd-tree-card__field-label">Payment Due</span>
                      <span class="dd-tree-card__field-value"
                        [ngClass]="isOverdue(inv.paymentDueDate) ? 'dd-tree-card__field-value--danger' : ''">
                        {{ inv.paymentDueDate | date:'dd MMM yyyy' }}
                        <span *ngIf="isOverdue(inv.paymentDueDate)" class="dd-overdue-badge" style="margin-left:4px;">
                          <i class="pi pi-exclamation-circle"></i> Overdue
                        </span>
                      </span>
                    </div>
                    <div class="dd-tree-card__field" *ngIf="inv.blDate">
                      <span class="dd-tree-card__field-label">BL Date</span>
                      <span class="dd-tree-card__field-value">{{ inv.blDate | date:'dd MMM yyyy' }}</span>
                    </div>
                    <div class="dd-tree-card__field" *ngIf="inv.delayedDays !== undefined">
                      <span class="dd-tree-card__field-label">Delayed Days</span>
                      <span class="dd-tree-card__field-value"
                        [ngClass]="inv.delayedDays > 0 ? 'dd-tree-card__field-value--warning' : 'dd-tree-card__field-value--success'">
                        {{ inv.delayedDays > 0 ? inv.delayedDays + ' days' : 'On Time' }}
                      </span>
                    </div>
                  </div>

                  <!-- Linked payment for this invoice -->
                  <ng-container *ngIf="getPaymentForInvoice(item, inv.invoiceNo) as pay">
                    <div class="dd-tree-card__outstanding"
                      [ngClass]="pay.paymentReceived ? 'dd-tree-card__outstanding--paid' : ''">
                      <span class="dd-tree-card__outstanding-label">
                        {{ pay.paymentReceived ? '✓ Paid' : '⏳ Outstanding' }}
                      </span>
                      <span class="dd-tree-card__outstanding-value">
                        {{ pay.paymentReceived
                            ? formatCurrency(pay.paymentPrice)
                            : formatCurrency(inv.invoicePrice - (pay.paymentPrice || 0)) }}
                      </span>
                    </div>
                    <!-- Progress -->
                    <div class="dd-tree-card__progress" *ngIf="inv.invoicePrice > 0">
                      <div class="dd-tree-card__progress-label">
                        <span>Paid {{ formatCurrency(pay.paymentPrice || 0) }}</span>
                        <span>{{ calcProgressPct(pay.paymentPrice, inv.invoicePrice) }}%</span>
                      </div>
                      <div class="dd-tree-card__progress-bar">
                        <div class="dd-tree-card__progress-fill"
                          [ngClass]="getProgressClass(pay.paymentPrice, inv.invoicePrice)"
                          [style.width]="calcProgressPct(pay.paymentPrice, inv.invoicePrice) + '%'">
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- No payment linked -->
                  <ng-container *ngIf="!getPaymentForInvoice(item, inv.invoiceNo)">
                    <div class="dd-tree-card__outstanding">
                      <span class="dd-tree-card__outstanding-label">⏳ Outstanding</span>
                      <span class="dd-tree-card__outstanding-value">{{ formatCurrency(inv.invoicePrice) }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-template #noInvoices>
              <div class="dd-no-items">
                <i class="pi pi-file"></i> No invoices raised yet
              </div>
            </ng-template>
          </div>

          <!-- ── PAYMENTS TREE ─────────────────────────────── -->
          <div class="dd-tree-section" *ngIf="detailDialogType === 'invoice' || detailDialogType === 'revenue'">
            <div class="dd-tree-section__header">
              <span class="dd-tree-section__title">
                <i class="pi pi-credit-card" style="color:#22c55e;"></i>
                Payments
              </span>
              <span class="dd-tree-section__total">
                <span>Received</span>{{ formatCurrency(calcTotalPayments(item)) }}
              </span>
            </div>

            <ng-container *ngIf="item.payments && item.payments.length > 0; else noPayments">
              <div class="dd-tree-card"
                *ngFor="let pay of item.payments; let pi = index"
                [ngClass]="pay.paymentReceived ? 'dd-tree-card--payment' : 'dd-tree-card--pending'">

                <!-- Toggle -->
                <div class="dd-tree-card__toggle"
                  (click)="toggleTreeCard('pay-' + item.orderId + '-' + pi)">
                  <div class="dd-tree-card__toggle-left">
                    <div class="dd-tree-card__toggle-icon"
                      [ngClass]="pay.paymentReceived ? 'dd-tree-card__toggle-icon--payment' : 'dd-tree-card__toggle-icon--pending'">
                      <i [class]="pay.paymentReceived ? 'pi pi-check' : 'pi pi-clock'"></i>
                    </div>
                    <div>
                      <div class="dd-tree-card__toggle-title">{{ pay.invoiceNo }}</div>
                      <div class="dd-tree-card__toggle-date">
                        {{ pay.paymentReceived
                            ? (pay.paymentReceivedDate | date:'dd MMM yyyy')
                            : 'Due: ' + (pay.invoiceDate | date:'dd MMM yyyy') }}
                      </div>
                    </div>
                  </div>
                  <div class="dd-tree-card__toggle-right">
                    <span class="dd-tree-card__toggle-amount">{{ formatCurrency(pay.paymentPrice) }}</span>
                    <span class="dd-tag" [ngClass]="pay.paymentReceived ? 'dd-tag--success' : 'dd-tag--warning'">
                      {{ pay.paymentReceived ? 'Paid' : 'Pending' }}
                    </span>
                    <i class="pi pi-chevron-down dd-tree-card__chevron"
                      [class.is-open]="isTreeCardOpen('pay-' + item.orderId + '-' + pi)"></i>
                  </div>
                </div>

                <!-- Expanded body -->
                <div class="dd-tree-card__body"
                  [class.is-open]="isTreeCardOpen('pay-' + item.orderId + '-' + pi)">
                  <div class="dd-tree-card__grid">
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Invoice Ref</span>
                      <span class="dd-tree-card__field-value">{{ pay.invoiceNo }}</span>
                    </div>
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Invoice Date</span>
                      <span class="dd-tree-card__field-value">{{ pay.invoiceDate | date:'dd MMM yyyy' }}</span>
                    </div>
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Payment Amount</span>
                      <span class="dd-tree-card__field-value">{{ formatCurrency(pay.paymentPrice) }}</span>
                    </div>
                    <div class="dd-tree-card__field">
                      <span class="dd-tree-card__field-label">Status</span>
                      <span class="dd-tree-card__field-value"
                        [ngClass]="pay.paymentReceived ? 'dd-tree-card__field-value--success' : 'dd-tree-card__field-value--warning'">
                        {{ pay.paymentReceived ? 'Received' : 'Pending' }}
                      </span>
                    </div>
                    <div class="dd-tree-card__field" *ngIf="pay.paymentReceived && pay.paymentReceivedDate">
                      <span class="dd-tree-card__field-label">Received Date</span>
                      <span class="dd-tree-card__field-value dd-tree-card__field-value--success">
                        {{ pay.paymentReceivedDate | date:'dd MMM yyyy' }}
                      </span>
                    </div>
                    <div class="dd-tree-card__field" *ngIf="!pay.paymentReceived">
                      <span class="dd-tree-card__field-label">Outstanding</span>
                      <span class="dd-tree-card__field-value dd-tree-card__field-value--warning">
                        {{ formatCurrency(pay.paymentPrice) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noPayments>
              <div class="dd-no-items">
                <i class="pi pi-credit-card"></i> No payments recorded yet
              </div>
            </ng-template>
          </div>

        </ng-container>
        <!-- /selectedDetailItem -->

      </div>
      <!-- /dd-body__detail -->
    </div>
    <!-- /dd-body -->
  </ng-template>

  <!-- ── Footer ─────────────────────────────────────────────── -->
  <ng-template pTemplate="footer">
    <div class="dd-footer">
      <div class="dd-footer__totals">
        <div class="dd-footer__total-item" *ngFor="let t of detailFooterTotals">
          <span class="dd-footer__total-label">{{ t.label }}</span>
          <span class="dd-footer__total-value" [ngClass]="'dd-footer__total-value--' + t.color">
            {{ t.formatted ? formatCurrency(t.value) : t.value }}
          </span>
        </div>
      </div>
      <div class="dd-footer__actions">
        <button pButton label="Close" icon="pi pi-times"
          class="p-button-outlined p-button-sm"
          (click)="detailDialogVisible = false"></button>
      </div>
    </div>
  </ng-template>

</p-dialog>

<!-- <app-quotation-footer></app-quotation-footer> -->